import React, { useState } from "react";
import { Link } from "react-router-dom";
// import TextEditor from "../../../feature-module/inventory/texteditor";
// import ImageWithBasePath from "../../img/imagewithbasebath";
import Select from "react-select";
import { DatePicker } from "antd";
import { Calendar } from "feather-icons-react/build/IconComponents";
import useCreateQuotation from "../../../controllers/useCreateQuotation";
import {
  LIST_CUSTOMER,
  LIST_PRODUCTS,
  LIST_WAREHOUSE,
} from "../../../apollo/queries";
import { getSelectedStoreDetails } from "../../../utils/helperFunctions";
import { Controller } from "react-hook-form";
import Dropdown from "../../../feature-module/components/Dropdown";
import ErrorMessage from "../../../feature-module/components/errorMessage";
import InputField from "../../../feature-module/components/InputField";
import { PlusCircle } from "feather-icons-react/build/IconComponents";
import { MinusCircle } from "react-feather";
import ImageWithBasePath from "../../img/imagewithbasebath";
import PropTypes from "prop-types";

const AddQuotation = ({ refetch }) => {
  const [productArray, setProductArray] = useState([]);
  const { values, functions } = useCreateQuotation(productArray, refetch);

  const [selectedWarehouse, setSelectedWarehouse] = useState(null);

  const handleReset = () => {
    functions.onCancel();
    setProductArray([]);
  };

  const handleChangeWarehouse = (selectedOption) => {
    console.log("handleChangeWarehouse", selectedOption);
    setSelectedWarehouse(selectedOption);
  };

  const handleChangeProduct = (selectedOption) => {
    setProductArray((prevArray) => {
      const existingProductIndex = prevArray.findIndex(
        (product) => product.product_id === selectedOption.value
      );

      if (existingProductIndex !== -1) {
        // Product already exists, increase its quantity
        return prevArray.map((product, index) =>
          index === existingProductIndex
            ? { ...product, quantity: String(Number(product.quantity) + 1) }
            : product
        );
      } else {
        // Add new product
        return [
          ...prevArray,
          {
            product_id: selectedOption.value,
            productName: selectedOption?.label,
            images: selectedOption?.images,
            quantity: "1",
            price: selectedOption.price,
          },
        ];
      }
    });
  };

  const status = [
    { value: "Pending", label: "Pending" },
    { value: "Confirmed", label: "Confirmed" },
  ];

  const handleQuantityChange = (index, action, e) => {
    e.preventDefault();
    const updatedArray = [...productArray];
    let currentIndex = updatedArray[index];

    currentIndex.quantity = parseInt(currentIndex.quantity, 10);
    if (action === "increment") {
      currentIndex.quantity += 1;
    } else if (action === "decrement" && currentIndex.quantity > 1) {
      currentIndex.quantity -= 1;
    }
    updatedArray[index] = currentIndex;
    setProductArray(updatedArray);
  };

  const handleDeleteItem = (index) => {
    setProductArray((prevArray) => {
      return prevArray.filter((item, i) => i !== index);
    });
  };

  const handleInputChange1 = (event, i) => {
    console.log("i", i, event.target.value);
    const value = parseInt(event.target.value, 10);
    if (!isNaN(value) && value >= 1) {
      productArray[i].quantity = event.target.value;
      setProductArray([...productArray]);
    } else {
      productArray[i].quantity = "";
      setProductArray([...productArray]);
    }
  };

  const handlePriceChange = (event, i) => {
    console.log("i", i, event.target.value);
    const value = parseFloat(event.target.value);
    if (!isNaN(value) && value >= 1) {
      productArray[i].price = event.target.value;
      setProductArray([...productArray]);
    } else {
      productArray[i].price = "";
      setProductArray([...productArray]);
    }
  };

  return (
    <div>
      {/*Add Quotation */}
      <div className="modal fade" id="add-units">
        <div className="modal-dialog purchase modal-dialog-centered stock-adjust-modal">
          <div className="modal-content">
            <div className="page-wrapper-new p-0">
              <div className="content">
                <div className="modal-header border-0 custom-modal-header">
                  <div className="page-title">
                    <h4>Add Quotation</h4>
                  </div>
                  <button
                    type="button"
                    className="close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    onClick={handleReset}
                  >
                    <span aria-hidden="true">×</span>
                  </button>
                </div>
                <div className="modal-body custom-modal-body">
                  {/* <form onSubmit={handleCLickAdd}> */}
                  <div className="row">
                    <div className="col-lg-4 col-md-6 col-sm-12">
                      <Controller
                        name="customer_id"
                        control={values.control}
                        rules={{ required: "Customer is required" }}
                        render={({ field }) => (
                          <Dropdown
                            field={field}
                            query={LIST_CUSTOMER}
                            dataKey="listCustomer"
                            variables={{
                              storeId: getSelectedStoreDetails("id"),
                            }}
                            label="Customer Name"
                            required={true}
                            placeholder="Select a Customer"
                            // onChange={handleChangeCustomer}
                          />
                        )}
                      />
                      <ErrorMessage
                        error={values.errors?.customer_id?.message}
                      />
                    </div>
                    <div className="col-lg-4 col-md-6 col-sm-12">
                      <div className="input-blocks">
                        <Controller
                          name="warehouse_id"
                          control={values.control}
                          rules={{ required: "Warehouse is required" }}
                          render={({ field }) => (
                            <Dropdown
                              query={LIST_WAREHOUSE}
                              dataKey="listWarehouse"
                              variables={{
                                storeId: getSelectedStoreDetails("id"),
                              }}
                              label="Warehouse"
                              required
                              placeholder="Select a Warehouse"
                              field={field}
                              onChange={handleChangeWarehouse}
                            />
                          )}
                        />
                        <ErrorMessage
                          error={values.errors?.customer_id?.message}
                        />
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-6 col-sm-12">
                      <div className="input-blocks">
                        <label>
                          Date <span>*</span>
                        </label>
                        <div className="input-groupicon calender-input mb-2">
                          <Calendar className="info-img" />
                          <Controller
                            name="quotation_date"
                            control={values.control}
                            rules={{ required: "Date is required" }}
                            render={({ field }) => (
                              <DatePicker
                                {...field}
                                required={true}
                                name="quotation_date"
                                onChange={(date) => {
                                  console.log("date", date);
                                  field.onChange(date);
                                }}
                                selected={field.value}
                                type="date"
                                className="filterdatepicker"
                                dateFormat="dd-MM-yyyy"
                                placeholder="Choose Quotation Date"
                              />
                            )}
                          />
                        </div>
                        <ErrorMessage
                          error={values.errors?.quotation_date?.message}
                        />
                      </div>
                    </div>
                    {/* <div className="col-lg-4 col-md-6 col-sm-12">
                        <div className="input-blocks"> */}
                    {/* <Controller
                            name="reference_number"
                            control={values.control}
                            // rules={{ required: "Refrence Number is required" }}
                            render={({ field }) => ( */}
                    {/* <InputField
                            name="reference_number"
                            required={true}
                            label="Refrence Number"
                            type="text"
                            placeholder="Enter Refrence Number"
                            value={formFields?.reference_number}
                            // {...field}
                            onChange={handleInputChange}
                          /> */}
                    {/* )}
                          /> */}
                    {/* <ErrorMessage
                            error={values.errors?.reference_number?.message}
                          /> */}
                    {/* </div>
                      </div> */}
                    <div className="col-lg-12 col-md-12 col-sm-12">
                      <div className="input-blocks mb-2">
                        <Controller
                          name="product_id"
                          control={values.control}
                          render={({ field }) =>
                            selectedWarehouse ? (
                              <Dropdown
                                query={LIST_PRODUCTS}
                                dataKey="listProduct"
                                variables={{
                                  storeId: getSelectedStoreDetails("id"),
                                  warehouseId: selectedWarehouse?.value,
                                }}
                                label="Product"
                                // required
                                placeholder="Select a Product"
                                field={field}
                                onChange={handleChangeProduct}
                              />
                            ) : (
                              <>
                                <label>Product</label>
                                <Select
                                  classNamePrefix="react-select"
                                  placeholder="Select a Product"
                                />
                              </>
                            )
                          }
                        />
                      </div>
                      <ErrorMessage
                        error={values.errors?.product_id?.message}
                      />
                    </div>
                    {/* <div className="col-lg-4 col-md-6 col-sm-12">
                        <div className="input-blocks"> */}
                    {/* <Controller
                            name="quantity"
                            control={values.control}
                            // rules={{ required: "Quantity is required" }}
                            render={({ field }) => ( */}
                    {/* <InputField
                            required={true}
                            name="quantity"
                            label="Quantity"
                            type="number"
                            placeholder="Enter Quantity"
                            value={formFields?.quantity}
                            // {...field}
                            // onKeyDown={handleKeyDown}
                            onChange={handleInputChange}
                          /> */}
                    {/* )}
                          /> */}
                    {/* <ErrorMessage
                            error={values.errors?.quantity?.message}
                          /> */}
                    {/* </div>
                      </div> */}
                  </div>
                  {/* <div className="row">
                    <div
                      className="col-lg-12"
                      style={{
                        textAlign: "right",
                        margin: "10px 0px 20px 0px",
                      }}
                    >
                      <button type="submit" className="btn btn-submit">
                        Add
                      </button>
                    </div>
                  </div> */}
                  {/* </form> */}
                  <div className="row">
                    <div className="col-lg-12">
                      <div className="modal-body-table">
                        <div className="table-responsive">
                          <table className="table  datanew">
                            <thead>
                              <tr>
                                <th className="p-4">Product</th>
                                <th className="p-4 text-center">Qty</th>
                                <th className="p-4 ml-20">Unit Cost</th>
                                <th className="p-4">Total Cost</th>
                                <th className="p-4">Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              {productArray?.length > 0 ? (
                                <>
                                  {productArray?.map((x, i) => (
                                    <tr
                                      key={i}
                                      style={{ background: "#ffffff" }}
                                    >
                                      <td className="p-4">
                                        <div className="productimgname">
                                          <Link
                                            to="#"
                                            className="product-img stock-img"
                                          >
                                            <ImageWithBasePath
                                              alt=""
                                              src={
                                                x.images?.length > 0
                                                  ? x.images
                                                  : "assets/img/product/noimage.png"
                                              }
                                              isApiImage={
                                                x.images?.length > 0
                                                  ? true
                                                  : false
                                              }
                                            />
                                            {/* <ImageWithBasePath
                                        src="assets/img/products/stock-img-02.png"
                                        alt="product"
                                      /> */}
                                          </Link>
                                          <Link to="#"> {x.productName}</Link>
                                        </div>
                                      </td>
                                      <td
                                        className="p-4 text-center"
                                        style={{ width: "100px" }}
                                      >
                                        <div className="product-quantity">
                                          <span
                                            className="quantity-btn"
                                            onClick={(e) => {
                                              if (x.quantity >= 1) {
                                                handleQuantityChange(
                                                  i,
                                                  "decrement",
                                                  e
                                                );
                                              }
                                            }}
                                          >
                                            <MinusCircle />
                                          </span>
                                          <input
                                            value={x.quantity}
                                            onChange={(e) =>
                                              handleInputChange1(e, i)
                                            }
                                            type="number"
                                            className="quntity-input"
                                          />
                                          <span
                                            className="quantity-btn"
                                            onClick={(e) =>
                                              handleQuantityChange(
                                                i,
                                                "increment",
                                                e
                                              )
                                            }
                                          >
                                            <PlusCircle className="plus-circle" />
                                          </span>
                                        </div>
                                      </td>
                                      <td className="p-4  text-center">
                                        <div
                                          className="product-quantity"
                                          style={{ width: "100px" }}
                                        >
                                          <input
                                            value={x.price}
                                            onChange={
                                              (e) => {
                                                console.log("eee", e);
                                                handlePriceChange(e, i);
                                              }
                                              // handleInputChange1(e, i)
                                            }
                                            type="number"
                                            className="quntity-input"
                                            style={{ width: "80px" }}
                                          />
                                        </div>
                                      </td>
                                      <td className="p-4">
                                        ${(x.quantity * x.price).toFixed(2)}
                                      </td>
                                      <td>
                                        <div className="action-table-data">
                                          <div className="edit-delete-action">
                                            <Link
                                              className="confirm-text p-2"
                                              to="#"
                                              onClick={() =>
                                                handleDeleteItem(i)
                                              }
                                            >
                                              <i
                                                data-feather="trash-2"
                                                className="feather-trash-2"
                                              ></i>
                                            </Link>
                                          </div>
                                        </div>
                                      </td>
                                    </tr>
                                  ))}
                                </>
                              ) : (
                                <tr>
                                  <td
                                    colSpan={5}
                                    className="p-4"
                                    style={{ textAlign: "center" }}
                                  >
                                    No Product
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-lg-3 col-md-6 col-sm-12">
                        <div className="input-blocks mb-3">
                          <Controller
                            name="order_tax"
                            control={values.control}
                            rules={{ required: "Order Tax is required" }}
                            render={({ field }) => (
                              <InputField
                                required={true}
                                label="Order Tax"
                                type="text"
                                placeholder="Enter Order Tax"
                                value={values.control}
                                {...field}
                              />
                            )}
                          />
                          <ErrorMessage
                            error={values.errors?.order_tax?.message}
                          />
                        </div>
                      </div>
                      <div className="col-lg-3 col-md-6 col-sm-12">
                        <div className="input-blocks mb-3">
                          <Controller
                            name="discount"
                            control={values.control}
                            rules={{
                              required: "Discount is required",
                            }}
                            render={({ field }) => (
                              <InputField
                                required={true}
                                label="Discount"
                                type="text"
                                placeholder="Enter Discount"
                                value={values.control}
                                {...field}
                              />
                            )}
                          />
                          <ErrorMessage
                            error={values.errors?.discount?.message}
                          />
                        </div>
                      </div>
                      <div className="col-lg-3 col-md-6 col-sm-12">
                        <div className="input-blocks mb-3">
                          <Controller
                            name="shipping"
                            control={values.control}
                            rules={{
                              required: "Shipping is required",
                            }}
                            render={({ field }) => (
                              <InputField
                                required={true}
                                label="Shipping"
                                type="text"
                                placeholder="Enter Shipping"
                                value={values.control}
                                {...field}
                              />
                            )}
                          />
                          <ErrorMessage
                            error={values.errors?.shipping?.message}
                          />
                        </div>
                      </div>
                      <div className="col-lg-3 col-md-6 col-sm-12">
                        <div className="input-blocks mb-3">
                          <label>
                            Status <span>*</span>
                          </label>
                          <Controller
                            name="status"
                            control={values.control}
                            rules={{ required: "Status is required" }}
                            render={({ field }) => (
                              <Select
                                classNamePrefix="react-select"
                                className="mb-2"
                                options={status}
                                placeholder="Select Status"
                                value={status.find(
                                  (item) => item.value === field?.value
                                )}
                                onChange={(selectedOption) =>
                                  field.onChange(selectedOption.value)
                                }
                              />
                            )}
                          />
                          <ErrorMessage
                            error={values.errors?.status?.message}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* <div className="col-lg-12">
                      <div className="input-blocks summer-description-box">
                        <label>Description</label>
                        <div id="summernote" />
                        <TextEditor />
                      </div>
                    </div> */}
                  <div className="modal-footer-btn">
                    <button
                      type="button"
                      className="btn btn-cancel me-2"
                      data-bs-dismiss="modal"
                      onClick={handleReset}
                    >
                      Cancel
                    </button>
                    <Link
                      onClick={functions.onSubmit}
                      to="#"
                      className="btn btn-submit"
                      isabled={values.loading}
                    >
                      {values.loading ? (
                        <>
                          <span className="spinner-border spinner-border-sm me-2"></span>
                          Submit
                        </>
                      ) : (
                        "Submit"
                      )}
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

AddQuotation.propTypes = {
  refetch: PropTypes.func,
};

export default AddQuotation;
